import React, { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { LoaderComponent } from "../../util/Loader";
import Global, { getUnReadedChats, isBusinessAccountType, saveReadedChat } from "../../util/Global";
import Pagination from "../../components/Pagination";
import { AlertContext } from "../../util/Alerter";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import NotFound from "../../components/NotFound";
import { useLocation } from "react-router-dom";

const USERS_URL = Global.backend + "/index.php/user/showallUsers";
const MES_MESSAGE_URL = Global.backend + "/index.php/api/message/allmessage";
const SEND_MESSAGE_URL = Global.backend + "/index.php/api/message/new";
const LAST_MESSAGE_URL = Global.backend + "/index.php/api/message/lastmessage";

const ITEMS_PER_PAGE = 5;

const Chat = () => {
    const urlUserId = Number(new URLSearchParams(useLocation().search).get("userId"))
    const [listMessage, setListMessage] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isMessagesLoading, setIsMessagesLoading] = useState(false);
    const [chatUserId, setChatUserId] = useState("");
    const [messageName, setMessageName] = useState("");
    const [text, setText] = useState("");

    const [isUserChatExist, setisUserChatExist] = useState(false)
    const [chattedUsers, setChattedUsers] = useState([]);
    const [nonChattedUsers, setNonChattedUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [lastMessages, setLastMessages] = useState({});
    const [viewType, setViewType] = useState('chatted');
    const [paginatedUsers, setPaginatedUsers] = useState([])

    const { unreadedChatUserIds, setunreadedChatUserIds } = useContext(DashboardHeaderContext)
    const { showAlert } = useContext(AlertContext)
    const { t } = useTranslation();

    const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)



    useEffect(() => {
        setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
        setpageTitle("chat")
        setalertTitle("")
        setnavLinks([])
    }, [])

    useEffect(() => {
        setisUserChatExist([...chattedUsers, ...nonChattedUsers].map(user => user.id).includes(chatUserId))
    }, [chatUserId])

    useEffect(() => {
        // check passed user id
        if (!isLoading && urlUserId) {
            fetchMessage(urlUserId);




            [...chattedUsers, ...nonChattedUsers].map(user => {
                if (user.id == urlUserId) {
                    if (chattedUsers.map(user => user.id).includes(user.id)) {
                        // check if chatted or non chatted user
                        setViewType("chatted")
                    } else {
                        setViewType("nonChatted")
                    }
                    setMessageName(getFullUserName(user));
                    return
                }
            })
        }
    }, [isLoading, urlUserId])


    useEffect(() => {
        setIsLoading(true);

        // Fetch all users
        axios.post(USERS_URL, { userId: localStorage.getItem("id") })
            .then((response) => {
                const allUsers = response.data;

                // Fetch last messages
                axios.post(LAST_MESSAGE_URL)
                    .then((response) => {
                        // last messages
                        const messages = response.data.messages;
                        setunreadedChatUserIds(getUnReadedChats(response))


                        const lastMessagesMap = {};


                        messages.forEach(msg => {
                            if (!msg.receiver_id || !msg.sender_id) {
                                return
                            }


                            if (msg.receiver_id == msg.sender_id) {
                                // sent to myself
                                lastMessagesMap[localStorage.getItem("id")] = msg
                            } else {
                                // check the new user if sender or receiver
                                if (msg.receiver_id != localStorage.getItem('id')) {
                                    lastMessagesMap[msg.receiver_id] = msg;
                                }
                                if (msg.sender_id != localStorage.getItem('id')) {
                                    lastMessagesMap[msg.sender_id] = msg;
                                }
                            }
                        });


                        const chattedUserIds = Object.keys(lastMessagesMap).map(id => Number(id))


                        // Split users into chatted and non-chatted
                        const chattedUsersList = allUsers.filter(user => chattedUserIds.includes(user.id));
                        const nonChattedUsersList = allUsers.filter(user => !chattedUserIds.includes(user.id));


                        // add message users that may not exist from allusers api (admin user) from last messages api
                        const anonymousIds = chattedUserIds.filter(userId => !chattedUsersList.map(user => user.id).includes(userId))
                        const chattedAdminList = anonymousIds.map((id) => {
                            const msg = lastMessagesMap[id]
                            // check if user is sender or receiver and save his data to chattedusersList
                            if (msg.sender_id != localStorage.getItem("id")) {
                                return {
                                    id: id,
                                    nom: msg.nomsender,
                                    prenom: msg.senderprenom,
                                    roles: msg.senderroles
                                };
                            } else {
                                return {
                                    id: id,
                                    nom: msg.nomreceiver,
                                    prenom: msg.prenomreceiver
                                };
                            }
                        })



                        setChattedUsers([...chattedUsersList, ...chattedAdminList]);
                        setNonChattedUsers(nonChattedUsersList);
                        setLastMessages(lastMessagesMap);
                        setIsLoading(false);
                    });
            });
    }, []);

    const filteredChattedUsers = useMemo(() => {
        return chattedUsers.filter(user => {
            const fullName = getUserName(user).toLowerCase();
            return fullName.includes(searchQuery.toLowerCase());
        });
    }, [chattedUsers, searchQuery]);

    const filteredNonChattedUsers = useMemo(() => {
        return nonChattedUsers.filter(user => {
            const fullName = getUserName(user).toLowerCase();
            return fullName.includes(searchQuery.toLowerCase());
        });
    }, [nonChattedUsers, searchQuery]);

    const fetchMessage = (userId) => {
        setIsMessagesLoading(true);
        setChatUserId(userId)

        axios.post(MES_MESSAGE_URL, {  user2: userId })
            .then((response) => {
                if (response.data.messages.length) {
                    // save last user message as readed
                    const lastMessage = response.data.messages[response.data.messages.length - 1]
                    saveReadedChat(userId, lastMessage.id)
                    setunreadedChatUserIds(unreadedChatUserIds.filter(id => id != userId))


                    const newlastMessages = lastMessages
                    newlastMessages[userId] = lastMessage
                    setLastMessages(newlastMessages)
                }




                setListMessage(response.data.messages);
            }).catch((err) => {
                showAlert("error", t("request.errorFetchingMessages"))
            }).finally(() => {
                setIsMessagesLoading(false)
            })
    }




    const sendMessage = () => {
        if (!text || !chatUserId || isMessagesLoading) {
            return;
        }

        // must be backend check not frontend
        if (!isUserChatExist) {
            return
        }

        setIsMessagesLoading(true);

        axios.post(SEND_MESSAGE_URL, {
            receiver: chatUserId,
            message: text
        }).then((response) => {
            setText("")
            fetchMessage(chatUserId)
        }).catch((err) => {
            showAlert("error", t("request.errorSendingMessage"))
        })
    }


    function getUserName(user) {
        if (isBusinessAccountType(user.compte ? user.compte : 0)) {
            return (user.entreprise?.nom + " (" + user.prenom + " " + user.nom + ")")
        } else {
            return (user.prenom + " " + user.nom)
        }
    }

    function getFullUserName(user) {
        return user.id == localStorage.getItem('id') ? `${getUserName(user) + " (" + t("me") + ")"}` : `${getUserName(user) + " " + (user.roles?.includes("ROLE_ADMIN") ? ("(" + t("admin") + ")") : "")}`
    }

    return (
        <LoaderComponent isLoading={isLoading}>
            {!isLoading &&
                <div className="container-fluid">
                    <div className="d-lg-flex">
                        <div className="chat-leftsidebar me-lg-4">
                            <div className="card">
                                <div className="p-4">
                                    <div className="search-box chat-search-box pb-4">
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={t("search")}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                            <i className="mdi mdi-magnify search-icon"></i>
                                        </div>
                                    </div>
                                    <div className="chat-leftsidebar-nav">
                                        <div className="d-flex justify-content-center mb-3">
                                            <button
                                                className={`btn ${viewType === 'chatted' ? 'btn-primary' : 'btn-secondary'}`}
                                                onClick={() => {
                                                    setViewType('chatted')
                                                }}
                                            >
                                                {t("chattedUsers")}
                                            </button>
                                            <button
                                                className={`btn ms-2 ${viewType === 'nonChatted' ? 'btn-primary' : 'btn-secondary'}`}
                                                onClick={() => {
                                                    setViewType('nonChatted')
                                                }}
                                            >
                                                {t("nonChattedUsers")}
                                            </button>
                                        </div>
                                        <div className="tab-content py-4">
                                            <div className="tab-pane show active" id="chat">
                                                <ul className="list-unstyled chat-list" style={{ maxHeight: "50vh", overflow: "auto" }}>
                                                    {!paginatedUsers.length && <NotFound />}
                                                    {paginatedUsers.map((user, index) => {

                                                        return (
                                                            <li key={index}>
                                                                <div
                                                                    className="card mb-4"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        fetchMessage(user.id);
                                                                        setMessageName(getFullUserName(user));
                                                                    }}
                                                                >
                                                                    <div className={"card-body d-flex align-items-center" + (user.id == chatUserId ? " ttm-bgcolor-grey" : "")}>
                                                                        {!user.photo && !(isBusinessAccountType(user.compte) && user.entreprise?.logo) ?
                                                                            <div className="avatar-xs me-3">
                                                                                <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                                                                    {user.nom ? user.nom[0] : "U"}
                                                                                </span>
                                                                            </div>
                                                                            :
                                                                            <div className="chat-avatar">
                                                                                <img
                                                                                    className="img-fluid rounded-circle" // added classes
                                                                                    src={`${Global.backend}/uploads/${!isBusinessAccountType(user.compte) ? user.photo : user.entreprise?.logo}`}
                                                                                    alt="avatar"
                                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }} // added styles
                                                                                />
                                                                            </div>
                                                                        }




                                                                        <div className="flex-grow-1">
                                                                            <h5 className="card-title mb-0 d-flex justify-content-between align-items-center">
                                                                                <span>{getFullUserName(user)}</span>
                                                                                {unreadedChatUserIds.includes(user.id) &&
                                                                                    <span className="badge bg-primary">{t("detailproduit21.1")}</span>}
                                                                            </h5>
                                                                            <p className="card-text text-truncate">
                                                                                {lastMessages[user.id]?.message || t("clickToChat")}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                                <Pagination itemsPerPage={ITEMS_PER_PAGE} items={viewType === 'chatted' ? filteredChattedUsers : filteredNonChattedUsers} setItems={setPaginatedUsers} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-100 user-chat">
                            <div className="card">

                                <div className="p-4 border-bottom">
                                    <h5 className="mb-1">
                                        {messageName}
                                    </h5>
                                </div>
                                <div className="p-4" style={{
                                    height: "50vh",
                                    /* min-height: 50vh; */
                                    overflow: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <LoaderComponent isLoading={isMessagesLoading}>
                                        {!isUserChatExist ? <NotFound /> :

                                            <div className="chat-conversation w-100 h-100">
                                                <ul className={"list-unstyled" + (!listMessage.length ? " h-100 d-flex justify-content-center align-items-center" : "")}>
                                                    {!listMessage.length && (
                                                        <li className="text-center">
                                                            <i className="mdi mdi-message-outline fs-1 text-muted"></i>
                                                            <p>{t("noMessages")}</p>
                                                        </li>
                                                    )}                                                {listMessage.map((msg, index) => {
                                                        const isSender = msg.sender.id == localStorage.getItem('id');
                                                        return (
                                                            <li key={index} className={isSender ? "right" : "left"}>
                                                                <div className="conversation-list">

                                                                    <div className="media">

                                                                        {!msg.sender.photo ? // no need to toggle between entreprise and user photo since API return only photo
                                                                            <div className="avatar-xs me-3">
                                                                                <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                                                                    {msg.sender.nom[0]}
                                                                                </span>
                                                                            </div>
                                                                            :
                                                                            <div className="chat-avatar">
                                                                                <img
                                                                                    className="img-fluid rounded-circle" // added classes
                                                                                    src={`${Global.backend}/uploads/${msg.sender.photo}`}   // no need to toggle between entreprise and user photo since API return only photo
                                                                                    alt="avatar"
                                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }} // added styles
                                                                                />
                                                                            </div>
                                                                        }


                                                                        <div className="media-body arrow-left ms-3">
                                                                            <div className="ctext-wrap" >
                                                                                <p>
                                                                                    {msg.message}
                                                                                </p>
                                                                                <p className="chat-time mb-0">
                                                                                    <i className="mdi mdi-clock-outline"></i>
                                                                                    <span>{moment(msg.date).format('HH:mm')}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>}

                                    </LoaderComponent>
                                </div>

                                <div className="p-4 border-top">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="position-relative">
                                                <input
                                                    disabled={!isUserChatExist || !chatUserId || isMessagesLoading}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("enterMessage")}
                                                    value={text}
                                                    autoFocus
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            sendMessage()
                                                        }
                                                    }}
                                                    onChange={(e) => setText(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <button disabled={!isUserChatExist || !chatUserId || isMessagesLoading} className="btn btn-primary w-100" onClick={() => sendMessage()}>
                                                <i className="mdi mdi-send"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </LoaderComponent>
    );
};

export default Chat;
